import { render, staticRenderFns } from "./RelacionarContent.vue?vue&type=template&id=deaf989c&scoped=true&"
import script from "./RelacionarContent.vue?vue&type=script&lang=js&"
export * from "./RelacionarContent.vue?vue&type=script&lang=js&"
import style0 from "./RelacionarContent.vue?vue&type=style&index=0&id=deaf989c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaf989c",
  null
  
)

export default component.exports